import axios from 'axios';
import { API_BASE_URL } from './url_config';

export const fetchStlife = async () => {
  return await axios.get(`${API_BASE_URL}/stlife/active`, { });
};